export const separateDots = (dots) => {
  const result = {};
  dots.forEach((item) => {
    if (result[item.properties.gen_name])
      result[item.properties.gen_name].push(item);
    else result[item.properties.gen_name] = [item];
  });

  return result;
};
